import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IPromiseCache } from './types'

export const PromiseCache = withDependencies([], (): IPromiseCache => {
	const cache = new Map<string, Promise<any>>()
	return {
		runWithCache: <T = any>(key: string, fn: () => Promise<T>): Promise<T> => {
			// Check if this URL is already being loaded or has been loaded
			const cachedPromise = cache.get(key)
			if (cachedPromise) {
				return cachedPromise as Promise<T>
			}

			const fnPromise = fn().catch((error) => {
				cache.delete(key)
				throw error
			})

			cache.set(key, fnPromise)

			return fnPromise
		},
	}
})
